import { memo, useEffect, useState } from "react";
import { Handle, Position, type NodeProps } from "@xyflow/react";
import {
  assetAvailability,
  assetContentUrl,
  assetThumbnailUrl,
  type VideoFlowNode
} from "./node-types.js";
import { useMeasuredHandles } from "./useMeasuredHandles.js";
import { canvasCopy } from "../../copy/zh-CN.js";

export const VideoNode = memo(function VideoNode({
  id,
  data,
  selected
}: NodeProps<VideoFlowNode>) {
  useMeasuredHandles(id, data.refreshHandles);
  const [mediaFailed, setMediaFailed] = useState(false);
  useEffect(() => setMediaFailed(false), [data.asset?.updatedAt, data.canvasNode.assetId]);
  const availability = assetAvailability(data.asset, mediaFailed);
  const previewEnabled = data.previewEnabled !== false;
  return (
    <article className={`asset-node asset-node--video${selected ? " asset-node--selected" : ""}`}>
      <Handle type="target" position={Position.Left} />
      <header><span>{canvasCopy.videoNode}</span><strong>{data.asset?.displayName ?? data.label}</strong></header>
      {(availability === "available" || availability === "unknown") && previewEnabled ? (
        <video
          controls
          preload="none"
          poster={data.previewUrl ?? assetThumbnailUrl(data.canvasNode.assetId)}
          {...(data.contentUrl === null ? {} : { src: data.contentUrl ?? assetContentUrl(data.canvasNode.assetId) })}
          aria-label={data.asset?.displayName ?? canvasCopy.videoNode}
          data-media-preview
          onError={() => setMediaFailed(true)}
        />
      ) : (
        <p className="asset-node__status" role="status">
          {!previewEnabled ? canvasCopy.mediaPreviewOmitted : availability === "trashed" ? canvasCopy.videoInTrash : canvasCopy.videoUnavailable}
        </p>
      )}
      <Handle type="source" position={Position.Right} />
    </article>
  );
});
